import { useMutation } from '@tanstack/react-query';

import { addMediaApi } from './api';

const useUploadImages = () => {
  const { mutateAsync } = useMutation(
    ['uploadIcon'],
    async ({ files, returnFormat }) => {
      const oldFilesPositions = [];
      const galleryFiles = [];

      files.forEach((file, index) => {
        if (typeof file === 'object') {
          oldFilesPositions.push(index);
          galleryFiles.push(file);
        }
      });

      if (!galleryFiles.length) {
        if (returnFormat) {
          return returnFormat(files);
        }

        return files;
      }

      const requestsGallery = galleryFiles.map((file) => {
        const formDataGallery = new FormData();
        formDataGallery.append('media', file);

        return addMediaApi(formDataGallery);
      });

      const [...data] = await Promise.all(requestsGallery);

      const finallyArr = [...files];

      data.forEach((res, index) => {
        finallyArr[oldFilesPositions[index]] = res.data;
      });

      if (returnFormat) {
        return returnFormat(finallyArr);
      }

      return finallyArr;
    },
    {
      onError: (error) => error,
    }
  );

  return { mutateAsync };
};

export default useUploadImages;
